import React from 'react';
import styles from '../css/Home.module.css';
import { Link } from 'react-router-dom';
import axiosInstance from '../config/axiosConfig';

export default function Home() {
  return (
    <div className={styles.contentWrapper}>
      <div className={styles.titleContainer}>
        <img
          src="/images/chart_curve.png"
          alt="chart_curve"
        />
        <h1 className={styles.title}>G-SAN</h1>
      </div>

      <div className={styles.tablesContainer}>
        <table className={styles.infoTable}>
          <tbody>
            <tr>
              <td className={styles.tableHeader}>
                <div className={styles.headerContent}>
                  <Link to="/tablero" className={styles.headerLink}>
                    <img src="/images/3d_bar_chart.png" alt="3d_bar_chart" className={styles.headerIcon} />
                    <span>Tablero</span>
                  </Link>
                </div>
              </td>
            </tr>
            <tr>
              <td className={styles.tableBody}>
                Tablero con gráficos estadísticos del índice de gobernanza
              </td>
            </tr>
          </tbody>
        </table>

        <table className={styles.infoTable}>
          <tbody>
            <tr>
              <td className={styles.tableHeader}>
                <div className={styles.headerContent}>
                  <Link to="/Datos" className={styles.headerLink}>
                    <img src="/images/table.png" alt="table" className={styles.headerIcon} />
                    <span>Datos Recolectados</span>
                  </Link>
                </div>
              </td>
            </tr>
            <tr>
              <td className={styles.tableBody}>
                Datos recolectados del índice de gobernanza en seguridad alimentaria y nutricional
              </td>
            </tr>
          </tbody>
        </table>

        <table className={styles.infoTable}>
          <tbody>
            <tr>
              <td className={styles.tableHeader}>
                <div className={styles.headerContent}>
                  <Link to="/Table" className={styles.headerLink}>
                    <img src="/images/table.png" alt="table" className={styles.headerIcon} />
                    <span>Datos Historicos</span>
                  </Link>
                </div>
              </td>
            </tr>
            <tr>
              <td className={styles.tableBody}>
                Historial sobre datos recolectados del indice de gobernanza en seguridad alimentaria y nutricional
              </td>
            </tr>
          </tbody>
        </table>

      </div>

      {/* <div className={styles.footerInfo}>
        <img
          src="/images/UnionEuropea.png"
          alt="Union Europea"
          className={styles.footerLogo}
        />
        <p className={styles.footerText}>
          La presente aplicación web ha sido desarrollada con el apoyo financiero de la Unión Europea a través del Proyecto Plataforma de información Nacional sobre Nutrición (PiNN) ejecutado por el CATIE (Centro Agronómico Tropical de Investigación y Enseñanza). El contenido de la presente aplicación es responsabilidad exclusiva de la Secretaría de Seguridad Alimentaria y Nutricional (SESAN) en ningún caso debe considerarse que refleja los puntos de vista de la Unión Europea.
        </p>
      </div> */}
    </div>
  );
}
